import { styled } from '@linaria/react'

import { Theme } from '../../types/common'
import Icon from '../icon'

const Container = styled.button`
  background-color: var(--secondary);
  width: 50px;
  height: 50px;
  border-radius: 7px;
  transition: all 0.2s ease-in-out;
  display: flex;
  margin-top: 5px;
  * {
    pointer-events: none;
  }
  &:hover {
    transform: scale(1.05);
  }
`

interface ThemeSwitchProps {
  theme: Theme
}

const ThemeSwitch = ({ theme }: ThemeSwitchProps) => {
  return (
    <Container className="flx-ctr" id="theme-switch" aria-label="Switch theme">
      {theme === 'dark' ? (
        <Icon id="moon" width="25" height="25" color="#fff" />
      ) : (
        <Icon id="sun" width="31" height="31" color="#0e091e" />
      )}
    </Container>
  )
}

export default ThemeSwitch
